import { useQuery } from "react-query";
import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";



const get96Well2DGraphData = async (plate_uuid) => {


    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qlp/thumb2d/${plate_uuid}`, {
        headers: headerConfig
    });

    return data;
};

export default function useFetchQlp96WellPlate2Dgraph(plate_uuid) {


    return useQuery('96WellPlate2DGraph', () => get96Well2DGraphData(plate_uuid), {
        onSuccess: (data) => {
            console.log({ data });
            //console.log(data);
        },

        onError: (error) => {
            //console.log(error);
        },

    });
};
